import { render, staticRenderFns } from "./HistoricoCargaPatrimonialEditar.vue?vue&type=template&id=d53ed3d8"
import script from "./HistoricoCargaPatrimonialEditar.vue?vue&type=script&lang=js"
export * from "./HistoricoCargaPatrimonialEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports